/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayoutTierPlace } from './PayoutTierPlace';
import {
    PayoutTierPlaceFromJSON,
    PayoutTierPlaceFromJSONTyped,
    PayoutTierPlaceToJSON,
    PayoutTierPlaceToJSONTyped,
} from './PayoutTierPlace';

/**
 * 
 * @export
 * @interface PayoutTier
 */
export interface PayoutTier {
    /**
     * Minimum participant count for this tier to apply (inclusive)
     * @type {number}
     * @memberof PayoutTier
     */
    minParticipants: number;
    /**
     * Maximum participant count (inclusive). Null for the final unbounded tier.
     * @type {number}
     * @memberof PayoutTier
     */
    maxParticipants?: number | null;
    /**
     * Ordered list of paid places. Percentages must sum to 100.
     * @type {Array<PayoutTierPlace>}
     * @memberof PayoutTier
     */
    places: Array<PayoutTierPlace>;
}

/**
 * Check if a given object implements the PayoutTier interface.
 */
export function instanceOfPayoutTier(value: object): value is PayoutTier {
    if (!('minParticipants' in value) || value['minParticipants'] === undefined) return false;
    if (!('places' in value) || value['places'] === undefined) return false;
    return true;
}

export function PayoutTierFromJSON(json: any): PayoutTier {
    return PayoutTierFromJSONTyped(json, false);
}

export function PayoutTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayoutTier {
    if (json == null) {
        return json;
    }
    return {
        
        'minParticipants': json['minParticipants'],
        'maxParticipants': json['maxParticipants'] == null ? undefined : json['maxParticipants'],
        'places': ((json['places'] as Array<any>).map(PayoutTierPlaceFromJSON)),
    };
}

export function PayoutTierToJSON(json: any): PayoutTier {
    return PayoutTierToJSONTyped(json, false);
}

export function PayoutTierToJSONTyped(value?: PayoutTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minParticipants': value['minParticipants'],
        'maxParticipants': value['maxParticipants'],
        'places': ((value['places'] as Array<any>).map(PayoutTierPlaceToJSON)),
    };
}

